import React from "react";
import styled, { css } from "styled-components";

const Error = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0px;

  font-family: Montserrat;
  font-weight: 700;
  color: white;
  font-size: 15px;

  background: #560000d1;
  color: #ffcfcf;
  padding: 8px;
  border-radius: 9px;
`;

export default Error;
